import {AppState} from '../../state/index';

export const getnewTenantData = (state: AppState) => state.newTenantData;